"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetworkAnalysisPortSchema = exports.NetworkAnalysisPortTypeSchema = exports.NetworkAnalysisPortType = void 0;
const zod_1 = require("zod");
var NetworkAnalysisPortType;
(function (NetworkAnalysisPortType) {
    NetworkAnalysisPortType["PowerNet"] = "PowerNet";
    NetworkAnalysisPortType["GroundNet"] = "GroundNet";
    NetworkAnalysisPortType["DigitalNet"] = "DigitalNet";
    NetworkAnalysisPortType["AnyNet"] = "AnyNet";
})(NetworkAnalysisPortType || (exports.NetworkAnalysisPortType = NetworkAnalysisPortType = {}));
exports.NetworkAnalysisPortTypeSchema = zod_1.default.nativeEnum(NetworkAnalysisPortType);
exports.INetworkAnalysisPortSchema = zod_1.default.object({
    type: exports.NetworkAnalysisPortTypeSchema,
    portId: zod_1.default.string(),
    netName: zod_1.default.string(),
});
//# sourceMappingURL=INetworkAnalysisPort.js.map